// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PAlignRightOutlinedSvg from "@fishx/icons-svg/es/asn/PAlignRightOutlined";
import FishxIcon from '../components/FishxIcon';

var PAlignRightOutlined = function PAlignRightOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PAlignRightOutlinedSvg
  }));
};

PAlignRightOutlined.displayName = 'PAlignRightOutlined';
export default React.forwardRef(PAlignRightOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PAlignRightOutlined.js
// module id = 3206
// module chunks = 0